// 디자인 시안(design/*.dc.html)의 값 그대로. 토스풍 라이트 단일 테마.
export const C = {
  bg: '#F7F8FA',
  card: '#FFFFFF',
  text: '#191F28',
  text2: '#4E5968',
  text3: '#6B7684',
  muted: '#8B95A1',
  faint: '#B0B8C1',
  line: '#F2F4F6',
  line2: '#EEF0F3',
  chip: '#F2F4F6',
  tile: '#EEF0F3',
  accent: '#3B6CF0',
  accentSoft: '#EAF0FF',
  good: '#1FA05F',
  goodSoft: '#E6F6EE',
  warnBg: '#FFF7ED',
  warnText: '#7C4A12',
  toggleOff: '#D1D6DB',
  dark: '#191F28',
} as const;

/** 홈 피드의 인더스트리얼 배색. 콘크리트 바탕에 검은 테두리, 형광 노랑은 액센트에만. */
export const D = {
  ground: '#C8C8C6',
  panel: '#FFFFFF',
  ink: '#111111',
  ink2: '#6E6E6B',
  ink3: '#9A9A96',
  line: '#D9D9D6',
  volt: '#E9FF00',
  alert: '#E4002B',
} as const;

export const R = { card: 20, tile: 14, badge: 13, chip: 17, button: 16, input: 16 } as const;

export const S = { screenX: 20, cardPad: 16, gap: 10 } as const;
